<div class="main-section-space">
    <router-outlet>
    </router-outlet>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: #fff ;margin-top:2em">Loading...</p>
</ngx-spinner>
<!-- footer -->
<app-footer></app-footer>
<!-- footer -->